import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { baseAxios } from "config";
import {
  Icon,
  Grid,
  IconButton,
  TextField,
  Button,
  Stack,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { Save } from "@mui/icons-material";
import useStyles from "layouts/pages/applicants/components/ApplicantOnboardingPanel/Attachments/styles";
import GenericModal from "components/GenericModal";
import FileDropzone from "components/Dropzone";
import useCompanyStore from "stores/useCompanyStore";
import { useAppContextController } from "context/AppContext";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import updateVenue from "layouts/pages/venues/actions/updateVenue";
import updateApplicant from "layouts/pages/applicants/actions/updateApplicant";
import updateEvent from "layouts/pages/events/actions/updateEvent";
import updateCompany from "api/companies/updateCompany";
import { getCommonBaseImageUrl, getCompanyImageUrl } from "utils/helpers/upload";
import MDButton from "components/MDButton";
import LoadingButton from "@mui/lab/LoadingButton";

const AddInvoiceToVenueButton = ({
  messageContext,
  attachmentSelection,
  setAttachmentSelection,
  venueObj,
  invoiceFile,
  invoiceFiles,
  disabled,
}) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const updateVenueMutation = useMutation(updateVenue);

  // const updateCompanyMutation = useMutation(updateCompany, {
  //   onError: () => enqueueSnackbar("Something went wrong!", { variant: "error" }),
  //   onSuccess: async (_, { body }) => {
  //     setCurrentCompany({ ...currentCompany, ...body });
  //     enqueueSnackbar(`Files have been saved on ${currentCompany?.name}`, { variant: "success" });
  //     setAttachmentSelection([...attachmentSelection, ...files]);
  //     setFiles([]);
  //     await queryClient.invalidateQueries("companies");
  //   },
  // });

  const processSingleFile = async (fileParam) => {
    let fileObject = null;
    const attachmentArray = [];
    const file = fileParam?.file;
    const form = new FormData();
    const invoiceFileName = fileParam?.fileName;
    const newFilename = `${invoiceFileName}-${Math.round(Math.random() * 10000000)}.pdf`;
    form.append("file", file, newFilename);

    if (messageContext === "Venue") {
      await baseAxios.post(`/upload/${venueObj?.slug}/invoices/${fileParam.subType}`, form);

      fileObject = {
        entity: messageContext,
        filename: newFilename,
        venueSlug: venueObj.slug,
        invoiceType: fileParam.subType,
        docType: "pdf",
        uploadDate: new Date(),
      };
    }
    // if (messageContext === "Customer") {
    //   await baseAxios.post(`/upload/${currentCompany?.slug}/company/other`, form);

    //   setFiles([
    //     ...files,
    //     {
    //       entity: messageContext,
    //       filename: file.name,
    //       companySlug: currentCompany?.slug,
    //       type: "Other",
    //       docType: file?.path?.split(".").pop(),
    //       uploadDate: new Date(),
    //     },
    //   ]);
    // }

    if (messageContext === "Venue") {
      if (!venueObj._id) {
        enqueueSnackbar("Cannot Update Venue -- No Venue ID!", { variant: "error" });
        return null;
      }
      await updateVenueMutation.mutateAsync(
        {
          venueId: venueObj._id,
          data: {
            invoiceAttachments: [
              ...(venueObj?.invoiceAttachments ?? []),
              {
                docType: "pdf",
                filename: newFilename,
                type: fileParam.subType,
                uploadDate: new Date(),
              },
            ],
          },
        },
        {
          onError: () => enqueueSnackbar("Something went wrong!", { variant: "error" }),
          // onSuccess: async (_, { data }) => {
          //   await queryClient.invalidateQueries("venueCustomer");
          //   enqueueSnackbar(`Files have been saved on ${venueObj?.name}`, {
          //     variant: "success",
          //   });
          //   setAttachmentSelection([...attachmentSelection, fileObject]);
          //   return fileObject;
          // },
        }
      );
      return fileObject;
    }
    // if (messageContext === "Customer") {
    //   if (!company._id) {
    //     enqueueSnackbar("Cannot Update Customer -- No Customer ID!", { variant: "error" });
    //     return;
    //   }
    //   await updateCompanyMutation.mutateAsync({
    //     companyId: currentCompany._id,
    //     body: {
    //       attachments: [
    //         ...(currentCompany?.attachments ?? []),
    //         ...files.map((attachment) => {
    //           return {
    //             docType: attachment.docType,
    //             filename: attachment.filename,
    //             uploadDate: attachment.uploadDate,
    //           };
    //         }),
    //       ],
    //     },
    //   });
    // }
    return null;
  };

  const onPressHandler = async () => {
    setLoading(true);

    try {
      const promises = [];
      if (invoiceFiles?.length) {
        for (let index = 0; index < invoiceFiles.length; index += 1) {
          const element = invoiceFiles[index];
          // eslint-disable-next-line no-await-in-loop
          promises.push(processSingleFile(element));
        }
      } else {
        promises.push(processSingleFile(invoiceFile));
      }
      await Promise.all(promises).then(async (data) => {
        await queryClient.invalidateQueries("venueCustomer");
        enqueueSnackbar(`Files have been saved on ${venueObj?.name}`, {
          variant: "success",
        });
        setAttachmentSelection([...attachmentSelection, ...data]);
      });
    } catch (e) {
      //
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoadingButton
      disabled={disabled}
      color="primary"
      variant="contained"
      fullWidth
      loading={loading}
      onClick={onPressHandler}
      sx={{ maxWidth: "180px" }}
    >
      <MDTypography variant="body2" color="white" sx={{ whiteSpace: "nowrap" }}>
        {`Add Invoice${invoiceFiles ? "s" : ""}`}
      </MDTypography>
    </LoadingButton>
  );
};

export default AddInvoiceToVenueButton;
